<template>
    <div id="mainNavAccount" @click="$emit('click', $event)">
        <div class="textual" v-if="isLogged">
            <div class="nombre">
                {{ accountGetUsuario.nombre + ' ' + accountGetUsuario.apellidos  | truncate(10) }}
            </div>
            <div class="email">
                {{ accountGetUsuario.email }}
            </div>
        </div>
        <div class="img-holder tappable v-centered circled">
            <img v-if="isLogged" :src="accountGetUsuario.imagenes_id_avatar | img" >
            <span v-else class="imoon-enter"></span>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'mainNavAccount',
        computed: {
            ...mapGetters(['accountGetUsuario', 'isLogged'])
        }
    }
</script>

<style lang="scss">
    @import '@/scss/app.scss';

    #mainNavAccount {
        display: flex;
        flex-flow: row;
        align-items: center;
        gap: 5px;
        .textual {
            flex: 1 0 auto;
            text-align: right;
            .nombre {
                font-size: 10px;
                color: $primary;
            }
            .email {
                font-size: 8px;
                display: none;
                color: $secondary;
            }
        }
        .img-holder {
            $imgSize: 3em !important;
            flex: 0 0 $imgSize;
            width: $imgSize;
            height: $imgSize;
            border: $primary-dark-border;
            span {
                font-size: 1.5em;
            }
            img {
                width: 100%; height: 100%;
                object-fit: cover;
                border-radius: 50%;
            }
        }
    }
</style>